type CustomIntentCallToAction = 'cc_sales_rep' | 'continue_conversation';
export enum CustomIntentBaseIntent {
  NOT_INTERESTED = 'not_interested',
  NOT_INTERESTED_NOW = 'not_interested_now',
  QUALIFIED = 'qualified',
  NOT_RIGHT_PERSON = 'not_the_right_person',
  REFERRAL = 'referral',
}
export type ConversationStatusMode = 'end_with_status' | 'continue';
export type CustomIntentConversationStatus =
  | 'qualified'
  | 'not_interested'
  | 'not_interested_now'
  | 'stop_responding'
  | 'unresponsive';
export type CcSalesRepMode = 'default' | 'specific' | 'group';

export interface CustomIntentSchema {
  actions: CustomIntentAction[];
  baseIntent: CustomIntentBaseIntent | null;
  callToAction: CustomIntentCallToAction | null;
  description: string;
  name: string;
  replyStrategy: string;
  id?: string | number;
}

export interface ConversationStatusActionSchema {
  conversationStatus: {
    mode: ConversationStatusMode;
    result?: CustomIntentConversationStatus;
  };
  enabled: boolean;
}
export interface CcSalesRepActionSchema {
  ccSalesReps: {
    mode: CcSalesRepMode;
    salesGroupId?: number;
    salesRepId?: number;
  };
  enabled: boolean;
}
export interface UpdateCrmValuesActionSchema {
  enabled: boolean;
  updateCrmValues: { field: string; type: string; value: string | boolean | number }[];
}

export type CustomIntentAction =
  | ConversationStatusActionSchema
  | CcSalesRepActionSchema
  | UpdateCrmValuesActionSchema;

export interface CustomIntentApiSchema {
  attributes: {
    callToAction: CustomIntentCallToAction;
    description: string;
    name: string;
    replyStrategy: string;
    actions?: CustomIntentAction[];
    baseIntent?: CustomIntentBaseIntent;
  };
  id: number | string;
  type: 'custom_intents';
}

export interface CustomIntentsApiSchema {
  data: CustomIntentApiSchema[];
}
export interface CustomIntentTemplatesApiSchema {
  templates: {
    actions: CustomIntentAction[];
    baseIntent: null;
    description: string;
    name: string;
    replyStrategy: string;
  }[];
}

export interface UpdateCustomIntentPayload extends CustomIntentSchema {
  id: string;
}

export interface CustomIntentFormRef {
  submit: () => void;
}

export interface CustomIntentFormSchema
  extends Omit<CustomIntentSchema, 'actions' | 'callToAction'> {
  ccSalesGroupId: string | null;
  ccSalesRepId: string | null;
  ccSalesRepsMode: CcSalesRepMode | null;
  conversationStatusMode: ConversationStatusMode | null;
  conversationStatusResult: CustomIntentConversationStatus | null;
  updateCrmField: string | null;
  updateCrmFieldType: string | null;
  updateCrmValue: string | boolean | number | null;
}

export interface CustomIntentEmailSchema {
  id: number | string;
  name: string;
  linkId?: number | string;
}
